import { Component, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { locales } from '../../../../config/i18n-config';
import { CanvasLayoutDataService } from '../../../angular-common/canvas-layout-data.service';
import { LocaleDataService } from '../../../angular-common/locale-data.service';
import { AboutDialogComponent } from '../../about-dialog/about-dialog.component';
import { BaseView } from '../../base-view';

@Component({
  selector: 'app-private-area-header',
  templateUrl: './private-area-header.component.html',
  styleUrls: ['./private-area-header.component.scss'],
})
export class HeaderComponent extends BaseView {

  locales = locales

  constructor(
    public localeDataService: LocaleDataService,
    public canvasLayoutDataService: CanvasLayoutDataService,
    protected _injector: Injector
  ) {
    super(_injector)
  }

  showAbout = () => this._injector.get(MatDialog).open(AboutDialogComponent, 
                                                       {disableClose: false, 
                                                        width: '500px',
                                                        maxWidth: '100vw',
                                                        direction: this.localeDataService.direction});

  public isSelectedLocale = (a, b) => a.split('-').join('_').toLowerCase() == b.split('-').join('_').toLowerCase()
}
